module.exports = __webpack_public_path__ + "img/point_sub.2a77f234.jpg";